import React, { PureComponent, Fragment } from 'react';
import { withSizes } from 'react-sizes';
import b from 'b_';

import './footer.css';

import { mapSizesToProps } from 'client/helpers/sizes';
import AppMenu from '@components/app-menu';

export interface SizeProps {
    isDesktop: boolean;
}

export interface ComponentProps {
    desktopVersionAlways: boolean;
}

type Props = SizeProps & ComponentProps;

const class_ = b.with('footer');

class Footer extends PureComponent<Props> {
    public onVersionTogglerClick = () => {
        const { desktopVersionAlways = false } = this.props;

        document.cookie = `desktop-version-always=${desktopVersionAlways ? 0 : 1}; secure; path=/`;

        window.location.reload();
    };

    public render() {
        const { isDesktop, desktopVersionAlways } = this.props;

        const currentYear = new Date().getFullYear();
        const feedbackUrl = 'https://feedback2.yandex.com/research/';

        return (
            <Fragment>
                <div className={class_()}>
                    <div key="footer-top">
                        {isDesktop && !desktopVersionAlways
                            ? <AppMenu key="footer-app-menu" />
                            : (
                                <div
                                    key="desktop-version-toggler"
                                    className={class_('desktop-version-toggler')}
                                    onClick={this.onVersionTogglerClick}
                                >
                                    {desktopVersionAlways ? 'Mobile version' : 'Full version'}
                                </div>
                            )
                        }
                    </div>
                    <div key="copyrights">
                        <a href="https://yandex.com">Yandex</a>, {currentYear}&nbsp;&nbsp;
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={feedbackUrl}
                        >
                            Feedback
                        </a>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default withSizes(mapSizesToProps)(Footer);
